import { SpecificFilterRow } from 'modules/search/types';
import { ParamsMap, SearchEntityEnum } from '../search-v3-types';
import {
  getEmptyParamsMap,
  getTimeRangeFilter,
  mergeParamsMap,
  getNegationFilter,
} from '../search-v3-utils';

export const formatComplexDateFilter = (
  rows: SpecificFilterRow[]
): ParamsMap | undefined => {
  if (!rows || rows.length < 1) {
    return undefined;
  }

  const formatted = rows
    .filter((row) => !!row.complexDateFilterValue) // moze sa zmenit potom na normalny row.timeRangeFilterValue
    .map((row) => {
      const paramsMap = getEmptyParamsMap();
      Object.keys(row?.filterOption?.targetFieldsComplex_v3 ?? {}).forEach(
        (key) => {
          const pkey = key as SearchEntityEnum;
          const filter = getTimeRangeFilter(
            row.complexDateFilterValue!,
            pkey === SearchEntityEnum.ORIGINATOR
              ? { from: 'originDateFrom', to: 'endDateTo' }
              : { from: 'timeRangeFrom', to: 'timeRangeTo' }
          );
          paramsMap[pkey] = [getNegationFilter(filter, !!row.negation)];
        }
      );
      return paramsMap;
    });

  return mergeParamsMap(formatted);
};
